import { AboutService } from './../../services/about.service';
import { SocialRedesService } from './../../services/social-redes.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent implements OnInit {
  socialreds: any[];
  titular: any;

  constructor(
    private socialService: SocialRedesService,
    private aboutService: AboutService
  ) {
    this.socialreds = socialService.socialred;
    // console.log(this.socialreds);

    this.titular = aboutService.titular;
    // console.log(this.titular);
  }

  ngOnInit(): void {}
}
